import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import useAuth from 'app/hooks/useAuth';

const JwtLogout = () => {
    const { logout } = useAuth();
    const history = useHistory();

    const handleLogout = async () => {
        try {
            await logout();
            history.replace('/session/signin');
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(() => {
        handleLogout();
    }, []); // Empty dependency array ensures this runs once on mount

    return null; // No need to render anything, as it's just logging out
};

export default JwtLogout;
